export default "__VITE_ASSET__CXK4qOTQ__"